import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Trophy } from 'lucide-react';

export function CTAFinal() {
  const { t } = useTranslation();
  return (
    <section className="section">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: '-100px' }}
        transition={{ duration: 0.5 }}
        className="container-narrow max-w-4xl"
      >
        <div className="relative p-12 sm:p-16 text-center overflow-hidden block-purple">
          <div className="absolute -inset-1 bg-enchant-grad blur-3xl opacity-30 pointer-events-none" />
          <div className="relative">
            <h2 className="font-pixel text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight">
              {t('cta_final.title')}
            </h2>
            <p className="mt-6 text-lg text-kquest-200 max-w-xl mx-auto">
              {t('cta_final.subtitle')}
            </p>
            <Link to="/submit" className="btn-gold text-base !px-10 !py-4 mt-10 inline-flex">
              <Trophy className="w-5 h-5" />
              {t('cta_final.button')}
            </Link>
          </div>
        </div>
      </motion.div>
    </section>
  );
}
